/* eslint-disable camelcase */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import reportProblemDialog from '../../assets/reportProblemDialog.png';
import { selectCurrentEmpid, selectCurrentUser } from '../../pages/login/authSlice';
import './reportProblem.scss';
import { useGetIssueTypesFilterQuery, useSaveProblemReportMutation } from './reportProblemSlice';

type ReportProblemProps = {
    hideFunction: () => void;
};

export const ReportProblem = ({ hideFunction }: ReportProblemProps) => {
    const loggedUser = useSelector(selectCurrentUser);
    const [issueType, setIssueType] = useState<any>(null);
    const [issueTypesData, setIssueTypesData] = useState<any>([]);
    const loggedUserId = useSelector(selectCurrentEmpid);
    const [reportProblemComment, setReportProblemComment] = useState('');
    const [dateOfIssue, setDateOfIssue] = useState(new Date());
    const [saveProblemReport, saveResponse] = useSaveProblemReportMutation();
    const [enableSubmit, setEnableSubmit] = useState(false);

    const { data: issueTypes } = useGetIssueTypesFilterQuery({}, { skip: !loggedUser });


    const onIssueTypeChange = (e: { value: any }) => {
        setIssueType(e.value);
    };
    const DateOnChange = (e: any) => {
        setDateOfIssue(e.value);
    };
    useEffect(() => {
        setIssueTypesData(issueTypes?.data);
    }, [issueTypes]);
    
    useEffect(() => {
        const isFormValid =
            issueType !== null &&
            reportProblemComment !== '' &&
            dateOfIssue !== null &&
            loggedUserId !== null;
        setEnableSubmit(isFormValid);
    }, [issueType, reportProblemComment, dateOfIssue, loggedUserId]);

    const Submit = () => {
        if (!issueType || !reportProblemComment || !dateOfIssue || !loggedUserId) {
          toast.error('Please fill all the fields');
          return;
        }
      
        const problemReportObj = {
          issue_type_id: issueType.issue_type_id,
          comments: reportProblemComment,
          issue_date: dateOfIssue,
          created_by: loggedUserId,
        };
      
        saveProblemReport(problemReportObj)
          .unwrap()
          .then(() => {
            console.log(saveResponse.data);
            toast.success('Problem Reported Successfully' );
            hideFunction();
          })
          .catch((error:any) => {
            console.error(error);
            toast.error('Problem Reporting Failed');
          });
      };

    return (
        <div>
            <h5 className="mb-3" style={{ fontSize: '24px', fontWeight: '600' }}>
                <img src={reportProblemDialog} alt="Report a Problem" className="pe-2" /> Report a problem
            </h5>
            <Divider />

            <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
                User Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Name</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {loggedUser}
                    </p>
                </div>
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Oracle ID</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {loggedUserId}
                    </p>
                </div>
            </div>

            <Divider />

            <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
                Issue Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Issue Type</h5>
                    <Dropdown
                        value={issueType}
                        options={issueTypesData}
                        onChange={onIssueTypeChange}
                        optionLabel="issue_type_name"
                        placeholder="Select Issue Type"
                        className="w-100"
                        style={{ borderRadius: '10px' }}
                    />
                </div>
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Date of Issue</h5>
                    <Calendar
                        id="basic"
                        value={dateOfIssue}
                        onChange={DateOnChange}
                        showIcon
                        className="custom-calendar"
                        disabled
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Comment</h5>
                    <InputTextarea
                        className="w-100"
                        value={reportProblemComment}
                        onChange={(e) => setReportProblemComment(e.target.value)}
                        rows={5}
                        maxLength={4000}
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>
            <div className="reportProblemcharLimit">4,000 Character Limit</div>
            <Button
                label="Submit"
                onClick={Submit}
                disabled={!enableSubmit}
                className="btn-primary ps-5 pe-5 float-end mt-3"
                style={{ borderRadius: '12px' }}
            />
        </div>
    );
};
